import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Select, Button, Spin} from 'antd'
import FormModalNext from './FormModalNext'
import {EyeOutlined} from '@ant-design/icons'
import mappingManagementAPI from '../../../apis/mappingManagementAPI'
import GroovyModal from './groovyModal'
import {withTranslation} from 'react-i18next'

@inject('mappingManagementStore')
@observer
class FormModal extends Component {
  state = {
    nextModalVisible: false,
    fieldsValue: {},
    inboundValue: '',
    outboundValue: '',
    mappingType: 'Request',
    groovyList: [],
    preGroovyList: [],
    postGroovyList: [],
    groovyId: '',
    preGroovyId: '',
    postGroovyId: '',
    groovyVisible: false,
    preGroovyVisible: false,
    postGroovyVisible: false,
    mappingAttribute: 'Base',
    groovyClient: null,
    groovyName: null,
    groovyScript: null
  }
  formRef = React.createRef()

  componentDidMount() {
    this.getGroovy()
    this.formRef.current.setFieldsValue({
      mappingType: 'Request',
      mappingAttribute: 'Base'
    })
  }

  getGroovy = () => {
    mappingManagementAPI.getGroovyAction('MAPPING').then(res => {
      this.setState({
        groovyList: res.data.data
      })
    })
    mappingManagementAPI.getGroovyAction('MAPPINGPRE').then(res => {
      this.setState({
        preGroovyList: res.data.data
      })
    })
    mappingManagementAPI.getGroovyAction('MAPPINGPOST').then(res => {
      this.setState({
        postGroovyList: res.data.data
      })
    })
  }
  onGroovyChange = (value) => {
    this.setState({
      groovyId: value
    })
  }
  onPreGroovyChange = (value) => {
    this.setState({
      preGroovyId: value
    })
  }
  onPostGroovyChange = (value) => {
    this.setState({
      postGroovyId: value
    })
  }
  handleGroovy = () => {
    this.setState({
      groovyId: this.formRef.current.getFieldValue('groovy')
    })
    if (this.formRef.current.getFieldValue('groovy')) {
      this.getGroovyDetail(this.formRef.current.getFieldValue('groovy'), 'groovyVisible')
    }
  }
  handleGroovyCancel = () => {
    this.setState({
      groovyVisible: false
    })
  }

  handlePreGroovy = () => {
    this.setState({
      preGroovyId: this.formRef.current.getFieldValue('preProcessing')
    })
    if (this.formRef.current.getFieldValue('preProcessing')) {
      this.getGroovyDetail(this.formRef.current.getFieldValue('preProcessing'), 'preGroovyVisible')
    }
  }

  getGroovyDetail = (id, key) => {
    mappingManagementAPI.getGroovyDetailAction(id).then(res => {
      let resData = res.data.data
      this.setState({
        groovyClient: resData.client,
        groovyName: resData.name,
        groovyScript: resData.script,
        [key]: true
      })
    }).catch(err => {
      console.log(err)
    })
  }

  handlePreGroovyCancel = () => {
    this.setState({
      preGroovyVisible: false
    })
  }

  handlePostGroovy = () => {
    this.setState({
      postGroovyId: this.formRef.current.getFieldValue('postProcessing')
    })
    if (this.formRef.current.getFieldValue('postProcessing')) {
      this.getGroovyDetail(this.formRef.current.getFieldValue('postProcessing'), 'postGroovyVisible')
    }
  }
  handlePostGroovyCancel = () => {
    this.setState({
      postGroovyVisible: false
    })
  }

  /*inboundType*/
  onChangeInbound = (value) => {
    const {mappingManagementStore} = this.props
    this.formRef.current.setFieldsValue({
      inboundName: undefined
    })
    mappingManagementStore.onGetInboundNameAction(value)
    this.setState({
      inboundValue: value
    })
    if (value === undefined) {
      this.setState({
        inboundValue: ''
      })
    }
  }
  onChangeOutbound = (value) => {
    const {mappingManagementStore} = this.props
    this.formRef.current.setFieldsValue({
      outboundName: undefined
    })
    mappingManagementStore.onGetOutboundNameAction(value)
    this.setState({
      outboundValue: value
    })
    if (value === undefined) {
      this.setState({
        outboundValue: ''
      })
    }
  }
  onChangeInboundName = (value, option) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onGetInboundAction(value)
  }
  onChangeOutboundName = (value, option) => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onGetOutboundAction(value)
  }
  /*next*/
  handleOk = () => {
    const {mappingManagementStore, handleCancel} = this.props
    const {fieldDataSource} = mappingManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        dataFieldMappings: JSON.parse(JSON.stringify(fieldDataSource).replace(/\//g, '.')),
        fieldFilters: [],
        inboundConfigId: fieldsValue.inboundName,
        name: fieldsValue.name,
        outboundConfigId: fieldsValue.outboundName,
        mappingType: fieldsValue.mappingType,
        mappingAttribute: fieldsValue.mappingAttribute,
      }
      if (fieldsValue.mappingAttribute === 'Base') {
        params.preProcessing = fieldsValue.preProcessing
        params.postProcessing = fieldsValue.postProcessing
      } else {
        params.groovy = fieldsValue.groovy
      }
      mappingManagementStore.onSaveMappingAction(params).then(res => {
        if (res && res.data && res.data.code === 0) {
          handleCancel()
        }
      })
    }).catch(err => {})

  }
  /*cancel*/
  handleCancelNext = () => {
    const {mappingManagementStore} = this.props
    mappingManagementStore.onChangeMappingDetails()
    this.setState({
      nextModalVisible: false
    })
  }

  onChangeMappingAttribute = (value) => {
    this.setState({
      mappingAttribute: value
    })
    this.formRef.current.setFieldsValue({
      groovy: null,
      preProcessing: null,
      postProcessing: null
    })
    this.setState({
      groovyId: '',
      preGroovyId: '',
      postGroovyId: ''
    })
  }

  render() {
    const {mappingManagementStore, addModalVisible, handleCancel, t} = this.props
    const {isFetchingAdd, inboundCustomerList, inboundNameList, outboundCustomerList, outboundNameList} = mappingManagementStore

    const mappingTypeList = [
      {label: 'Request', value: 'Request'},
      {label: 'Response', value: 'Response'}
    ]
    const mappingAttributeList = [
      {label: 'Base', value: 'Base'},
      {label: 'Groovy', value: 'Groovy'},
      {label: 'None', value: 'None'},
      {label: 'OnlyCopy', value: 'OnlyCopy'}
    ]
    return (
      <>
        <Modal
          title={`${t(`general.add`)} ${t(`mappingManagement.mapping`)}`}
          closable={true}
          visible={addModalVisible}
          // onOk={this.handleOk}
          onCancel={handleCancel}
          width="50%"
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetchingAdd}>
            <Form ref={this.formRef} key="addMapping"
                  initialValues={{name: '', inboundType: null, inboundName: null, outboundType: null, outboundName: null}} layout="vertical">
              <Row justify="start" gutter={[10, 0]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                  <Form.Item name="name" label={t(`mappingManagement.mappingName`)}
                             rules={[{
                               required: true,
                               message: `${t(`general.pleaseEnter`)} ${t(`mappingManagement.mappingName`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }]}>
                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                  <Form.Item name="mappingType" label={t(`mappingManagement.mappingType`)}
                             rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.mappingType`)}`,}]}
                             defaultValue="Request">
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                      {mappingTypeList.length > 0 ? mappingTypeList.map(item => <Select.Option key={item.value}
                                                                                               value={item.value}>{item.label}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                  <Form.Item name="mappingAttribute" label={t(`mappingManagement.mappingAttribute`)}
                             rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.mappingAttribute`)}`,}]}
                             defaultValue="Base">
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeMappingAttribute}>
                      {mappingAttributeList.length > 0 ? mappingAttributeList.map(item => <Select.Option key={item.value}
                                                                                                         value={item.value}>{item.label}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                {
                  this.state.mappingAttribute === 'Groovy' ? (
                    <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                      <Form.Item label={t(`mappingManagement.groovy`)}
                                 rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.groovy`)}`,}]}>
                        <Row gutter={8}>
                          <Col span={16}>
                            <Form.Item name="groovy" noStyle>
                              <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onGroovyChange} allowClear>
                                {this.state.groovyList.length > 0 ? this.state.groovyList.map(item => <Select.Option key={item.id}
                                                                                                                     value={item.id}>{item.name}</Select.Option>) : null}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <Button style={{marginTop: '5px'}} type="link" icon={<EyeOutlined/>} onClick={this.handleGroovy}
                                    title={t(`general.display`)}/>
                          </Col>
                        </Row>
                      </Form.Item>
                    </Col>
                  ) : null
                }
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                  <Form.Item name="inboundCustomer" label={t(`mappingManagement.inboundCustomer`)}
                             rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.inboundCustomer`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeInbound} showSearch>
                      {inboundCustomerList.length > 0 ? inboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                       value={item.id}>{item.customer}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                  <Form.Item name="inboundName" label={t(`mappingManagement.inboundName`)}
                             rules={[{
                               required: this.state.inboundValue === '' ? false : true,
                               message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.inboundName`)}`,
                             }]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.inboundValue === ''} showSearch
                            onChange={this.onChangeInboundName}>
                      {inboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                  <Form.Item name="outboundCustomer" label={t(`mappingManagement.outboundCustomer`)}
                             rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.outboundCustomer`)}`,}]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear onChange={this.onChangeOutbound} showSearch>
                      {outboundCustomerList.length > 0 ? outboundCustomerList.map(item => <Select.Option key={item.id}
                                                                                                         value={item.id}>{item.customer}</Select.Option>) : null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                  <Form.Item name="outboundName" label={t(`mappingManagement.outboundName`)}
                             rules={[{
                               required: this.state.outboundValue === '' ? false : true,
                               message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.outboundName`)}`,
                             }]}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear disabled={this.state.outboundValue === ''} showSearch
                            onChange={this.onChangeOutboundName}>
                      {outboundNameList.map(item => <Select.Option key={item.id} value={item.id}>{item.apiName}</Select.Option>)}
                    </Select>
                  </Form.Item>
                </Col>
                {
                  this.state.mappingAttribute === 'Base' ? (
                    <>
                      <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                        <Form.Item label={t(`mappingManagement.preProcessing`)}>
                          <Row gutter={8}>
                            <Col span={20}>
                              <Form.Item name="preProcessing" noStyle>
                                <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onPreGroovyChange} allowClear>
                                  {this.state.preGroovyList.length > 0 ? this.state.preGroovyList.map(item => <Select.Option key={item.id}
                                                                                                                             value={item.id}>{item.name}</Select.Option>) : null}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col span={4}>
                              <Button type="link" icon={<EyeOutlined/>} onClick={this.handlePreGroovy} title={t(`general.display`)}/>
                            </Col>
                          </Row>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} span={8}>
                        <Form.Item label={t(`mappingManagement.postProcessing`)}>
                          <Row gutter={8}>
                            <Col span={20}>
                              <Form.Item name="postProcessing" noStyle>
                                <Select placeholder={t(`general.pleaseSelect`)} onChange={this.onPostGroovyChange} allowClear>
                                  {this.state.postGroovyList.length > 0 ? this.state.postGroovyList.map(item => <Select.Option key={item.id}
                                                                                                                               value={item.id}>{item.name}</Select.Option>) : null}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col span={4}>
                              <Button type="link" icon={<EyeOutlined/>} onClick={this.handlePostGroovy} title={t(`general.display`)}/>
                            </Col>
                          </Row>
                        </Form.Item>
                      </Col>
                    </>
                  ) : null
                }

              </Row>
            </Form>
          </Spin>
        </Modal>
        {this.state.nextModalVisible ? <FormModalNext
          nextModalVisible={this.state.nextModalVisible}
          fieldsValue={this.state.fieldsValue}
          handleCancel={handleCancel}
          handleCancelNext={this.handleCancelNext}
        /> : null}

        {this.state.groovyVisible ? <GroovyModal
          verVisible={this.state.groovyVisible}
          handleCancel={this.handleGroovyCancel}
          id={this.state.groovyId}
          state={this.state}
        /> : null}
        {this.state.preGroovyVisible ? <GroovyModal
          verVisible={this.state.preGroovyVisible}
          handleCancel={this.handlePreGroovyCancel}
          id={this.state.preGroovyId}
          state={this.state}
        /> : null}
        {this.state.postGroovyVisible ? <GroovyModal
          verVisible={this.state.postGroovyVisible}
          handleCancel={this.handlePostGroovyCancel}
          id={this.state.postGroovyId}
          state={this.state}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(FormModal)
